import { PaymentRequests } from './../models/paymentRequests';
import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse,HttpParams} from '@angular/common/http';
import { retry, catchError, map, take } from 'rxjs/operators';
import { rejects } from 'assert';
import { async } from '@angular/core/testing';
import { HttpRequestMethod } from './http/request-methods';
import { HttpApiService } from './http/http-api.service';
import { config } from '../models/config';
import { environment } from '../../../environments/environment';


class ImageSnippet {
  constructor(
    private afs: AngularFirestore,
    public src: string,
    public file: File
    ) {}
}

export class Attachment {
  constructor(public url: string,  public file: File,public fileName: string,public is_ihunter: number) {}
}

@Injectable({
  providedIn: 'root'
})
export class PaymentrequestsService {
  paymentRequestCollection: AngularFirestoreCollection<PaymentRequests>;
  paymentRequestDoc: AngularFirestoreDocument<PaymentRequests>;
  beneficiaries: Observable<PaymentRequests[]>;
  paymentRequest: Observable<PaymentRequests>;

  // Esta variable ya se encuentra en environment
  // private urlapi = 'https://api.ihunter.io/api/';

    // Http Headers
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
      })
    };
  


  constructor(
              private httpApiService: HttpApiService,
              private afs: AngularFirestore,
              private httpClient: HttpClient) {
    this.paymentRequestCollection = this.afs.collection('paymentRequests', (ref) =>
      ref.orderBy('companyId', 'asc')
    );
  }


  getPaymentRequests(idCompany: string, level: number,userId: string): Observable<PaymentRequests> {
    return this.httpClient.post<any>(environment.urlApi +'payments/getPaymentRequests',{'idCompany':idCompany, 'level':level, 'userId': userId})
    .pipe(catchError(this.errorMgmt));
  }

  sendMails(datosCorreo: any){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.POST,`email/sendEmail`,datosCorreo);
  }

  getBancos(){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`payments/getBancos`);
  }

  getPaymentRequestEdit(id: string,idCompany:string): Observable<PaymentRequests> {
    return this.httpClient.get<any>(`${environment.urlApi}payments/getPaymentRequestEdit?idPayment=`+id)
    .pipe(catchError(this.errorMgmt));
  }

  newPaymentRequest(
    paymentRequest: PaymentRequests,
    list_files: Attachment[],
    idCompany: string,
    companyName: string,
    email:string,
    is_ihunter: string
    ): Observable<any>  {
      try {        
        let index = 0;
        const formData = new FormData();
        list_files.forEach(function (value) {
          formData.append('file', value.file);
        });

        formData.append('paymentRequest',JSON.stringify(paymentRequest));
        formData.append('idCompany',idCompany);
        formData.append('companyName',companyName);
        formData.append('email',email);
        formData.append('is_ihunter',is_ihunter);
        return this.httpClient.post<any>(environment.urlApi + 'payments/newPaymentRequest/', formData).pipe(
          catchError(this.errorMgmt)
        );
      } catch (err) {

      }
  }

  updatePaymentRequestStatus(
    idPayment: number,
    status: number,
    message: string,
    liderStatusId: number
  ): Observable<any>{
    try {
      const props = {
        'idPayment':idPayment,'status':JSON.stringify(status), 'message': message,'liderStatusId': liderStatusId
      }
      return this.httpClient.post<any>(environment.urlApi + 'payments/updatePaymentRequestStatus/',props).pipe(
        catchError(this.errorMgmt)
      );
    } catch (error) {
      console.log(error);
    }
  }
  

  // Error handling
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  getRecibo(data: any){
    return this.httpApiService.apiReportFunction(HttpRequestMethod.POST, `payments/getRecibo/`, data, {responseType: 'arraybuffer'});
  }
  deleteFile(attachmentId: number){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`payments/deleteFile/${attachmentId}`);
  }

  deletePaymentRequests() {}
}
